import React, { Component } from "react";
import Cache from 'c-cache';
import Masonry from 'react-masonry-component';
import PbAjax from 'up-pbajax';
import publicpb from '../base/public.pb';
import lang from '../lang';
import global from '../base/global';
import listpb from './personvideolist.pb';
import { ListItem, ListItemTemp } from './item';

class PersonVideoList extends Component { 
    static defaultProps = {
        countryCode: 'CN',
        scrollable: true,
        pageSize: 20,
        threshold: 400
    }

    constructor(props) {
        super(props);
        
        this.state = {
            list: [],
            isLoading: true, // 正在加载
            isEmpty: false, // 没有数据
            isEnd: false // 数据已经加载完

        }

        this.cache = new Cache({
            prefix: 'h5uplive',
            uid: props.uid,
            expires: 24 * 3600 * 1000
        });

        this.pbajax = new PbAjax();
        this.page = 0;
        this.lastSortNo = 0;
        this.pageSize = props.pageSize;
        
        this.fetching = false; // 加载状态加锁
        this.first = true; // 第一页
        this.dataOver = false // 数据最后一页
    }

    componentWillMount() {
       
    }

    componentDidMount() {
        this.fetching = true;
        this.getData();
    }
    componentWillUnmount() {
        this.pbajax.cancel(); 
    }

    getData() {
        let self = this;
        let { Request, Response} = listpb.Dynamic.List;
        
        let lastRid = this.lastRid ? this.lastRid : 0;

        let businessData = new Request({
            lastRid: lastRid,
            vuid: this.props.uid
        });

        this.pbajax.do(
            {
                service: 'dynamic',    
                api: '/dynamic/list',  
                header: {
                    lang: lang.type,
                    userToken: global.getUser().userToken,
                    UserAgent: global.getGlobalUA
                }
            }, 
            businessData, 
            (res)=>{
                let dataWrap = publicpb.Result.decode(res);
                
                if (dataWrap.code == 1) {
                    let dataAll;
                    let data = [];

                    if (dataWrap.data.value) {
                        dataAll = Response.decode(dataWrap.data.value);
                        
                        this.lastSortNo =  dataAll.lastSortNo;
                        this.page = dataAll.pageIndex;

                        data = dataAll.dynamicInfos;    
                        this.lastRid = window.longToString(dataAll.lastRid);
                    }

                    let list  = this.state.list;

                    let newState = {
                        list: [...list, ...data]
                    };

                    if (data.length < this.pageSize) { 
                        // 数据加载完
                        this.dataOver = true;
                        newState.isLoading = false;

                        if (this.first) {
                            if (data.length == 0) {
                                newState.isEmpty = true;
                            }
                        } else {
                            newState.isEnd = true;
                        }
                    }

                    if (this.first) {
                        // 第一页
                        this.first = false;
                        // 仅缓存第一页数据
                        // this.cache.setCache('hostvideoList', data.slice(0,20));
                    }

                    if (!this.props.scrollable) {
                        newState.isLoading = false;
                    }

                    this.setState(Object.assign({}, this.state, newState));
                }

                this.fetching = false;
            },
            ()=>{
                this.fetching = false;
            }
        );
    }

    scroll() {
        
        let self = this;
        let page = this.state.page;

        self.timer && clearTimeout(self.timer);
        self.timer = setTimeout(function() {
            if (self.dataOver) {
                return;
            }
            if (self.fetching) {
                return;
            }
            let body = document.body,
                docElement = document.documentElement;
            
            // 700 在页面滑到底部前700px就可以加载,增加交互流畅性
            if (body.scrollTop > docElement.offsetHeight - docElement.clientHeight - self.props.threshold) {
                
                this.fetching = true;
                
                setTimeout(()=>{
                    self.getData();
                }, 0);
            }

        }, 300);
    }

    handleLayoutReady() {
        $(this.refs.cols).css({
            visibility: 'visible'
        });
    }
    
    render() {
        let { list } = this.state;
        let $ListArr;
        let $loading;
        let $empty;

        $ListArr = list.map((item, i) => {
            return <ListItem key={i} item={item} />;
        })
    

        $empty = (
            <div className="mini-empty">
                <i></i>
                <span className="tip">{ lang.template('记录你的精彩瞬间，让世界一起见证')}</span>
            </div>
        );

        var masonryOptions = {
            transitionDuration: 0
        };

        return (
            <div ref="wrap">
                 <div ref="cols" style={{visibility: 'hidden'}}>
                    <Masonry
                        className={'video-list'} // default ''
                        elementType={'ul'} // default 'div'
                        options={masonryOptions} // default {}
                        disableImagesLoaded={false} // default false
                        updateOnEachImageLoad={true} // default false and works only if disableImagesLoaded is false
                        onLayoutComplete={this.handleLayoutReady.bind(this)}
                    >
                         { $ListArr }
                    </Masonry>
                </div>
                { 
                    this.state.isLoading ? (
                        <div className="mini-loading">
                            <div className="loading-tip">{lang.template('正在加载')}<em>.</em><em>.</em><em>.</em></div>
                        </div>
                    ) : null 
                }
                { 
                    this.state.isEmpty ? $empty : null 
                }

            </div>
        );

    }
}

export default PersonVideoList;


// WEBPACK FOOTER //
// ./js/videolist/person.js